import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { base_url } from '../baseURL'
import Footer from '../main-components/Footer'
import Header from '../main-components/Header'
import { amenitiesData, projectdiscoverData, projectlistData, projectsdetailsData, projectserviceData } from '../redux/sliceData/sliceData'
import ProjectsBanner from './sub-component/projects/Projects_banner'
import ProjectsMain from './sub-component/projects/Projects_main'
import { Helmet } from 'react-helmet'

export default function Projects() {
  const dispatch = useDispatch()

  useEffect(() => {

      // Project Function
      ;(async () => {

          const response1 = await fetch(`${base_url}/projectdiscover`)
          const data1 = await response1.json()
          dispatch(projectdiscoverData(data1.projectdiscover))

          const response2 = await fetch(`${base_url}/projectlist`)
          const data2 = await response2.json()
          dispatch(projectlistData(data2.projectlist))

          const response3 = await fetch(`${base_url}/amenities`)
          const data3 = await response3.json()
          dispatch(amenitiesData(data3.amenities))

          const response4 = await fetch(`${base_url}/projectservice`)
          const data4 = await response4.json()
          dispatch(projectserviceData(data4.projectservice))

          const response5 = await fetch(`${base_url}/projectdetails`)
          const data5 = await response5.json()
          dispatch(projectsdetailsData(data5.projectdetails))

      })()
  },[])
  return (
    <>
      <Helmet>
                <meta charSet="utf-8" />
                <title>Best Construction Company in Delhi & Gurgaon. Jain Developers
About Jain Developers | Best Interior Designers in 2023.
Property Collaboration Services in Delhi NCR & Gurgaon.
Turnkey Construction in Delhi NCR & Gurgaon | Jain Developers.
Top real estate developers in Delhi NCR & Gurgaon | Contact us.
Discover our Turnkey and Collaborative Projects Jain Developers</title>
<meta name="description" content="Best Home Construction Companies in Delhi NCR & Gurgaon. MCG MCD map sanction, liaison service & Demolition in Delhi Gurgaon. | Jain Developers.
For more than 2 decades, Jain Developers has been Delhi's & Gurgaon renowned developers for its quality of constructions. Contact us for more details.
Jain Developers is trusted partner for property collaborations in Delhi NCR and Gurgaon. Specialize in turnkey solutions for residential and commercial projects.
Jain Developers is top Turnkey Construction developers in Delhi NCR and Gurgaon that handle entire construction process with your budget.
Jain Developers is leading in Collaboration and Turnkey developers in Delhi & Gurgaon. Do follow contact us for your dream project in your budget.
Explore our portfolio of completed turnkey and collaborative projects. From luxurious residential complexes to cutting-edge commercial spaces."/>

                {/* <link rel='canonical'/> */}
                <link rel="canonical" href="https://jaindevelopers.in/projects" />
            </Helmet>
    <Header/>
<ProjectsBanner/>
<ProjectsMain/>
    <Footer/>
    </>
  )
}
